define('TescoMobile_Checkout/js/action/place-order',['Magento_Checkout/js/model/quote', 'Magento_Checkout/js/action/place-order', 'Magento_Checkout/js/action/redirect-on-success'], function (quote, placeOrderAction, redirectOnSuccessAction) {
  'use strict';

  return function (accountNumber, orderStatus, messageContainer) {
    quote.billingAddress(null);
    const payload = {
      method: quote.getTotals()().base_grand_total > 0 ? 'tescomobile_aci_credit_card' : 'free',
      extension_attributes: {
        tm_account_number: accountNumber,
        hansen_order_status: orderStatus
      }
    };
    placeOrderAction(payload, messageContainer).done(function () {
      redirectOnSuccessAction.execute();
    });
  };
});

